import React, { useState, useRef, useEffect } from 'react';
const resizeAndPositionImage = (ref, maxWidth, maxHeight, maxArea, position = 'topLeft') => {
    const height = ref.height;
    const width = ref.width;
    const aspectRatio = height / width;
    const maxDimension = Math.max(ref.height, ref.width);
    let usedMaxHeight = maxHeight;
    let usedMaxWidth = maxWidth;
    if (isNaN(aspectRatio)) {
        return;
    }
    if (maxDimension === height) {
        usedMaxHeight = Math.sqrt((maxArea * height) / width);
        usedMaxWidth = (usedMaxHeight * width) / height;
    }
    else if (maxDimension === width) {
        usedMaxWidth = Math.sqrt((maxArea * width) / height);
        usedMaxHeight = (usedMaxWidth * height) / width;
    }
    const overlayPadding = 75;
    return Object.assign({ height: usedMaxHeight, width: usedMaxWidth }, {
        topLeft: { x: overlayPadding, y: overlayPadding },
        topRight: { x: 1920 - overlayPadding - usedMaxWidth, y: overlayPadding },
        bottomLeft: { x: overlayPadding, y: 1080 - overlayPadding - usedMaxHeight },
        bottomRight: { x: 1920 - overlayPadding - usedMaxWidth, y: 1080 - overlayPadding - usedMaxHeight }
    }[position]);
};
export const MaxAreaWatermark = ({ src = '', belowGfx = false, position = 'topRight', 
// these are for 1920 width screens
maxHeight = 500, 
// these are for 1920 width screens
maxWidth = 500, 
// these are for 1920 width screens
maxArea = 30000 }) => {
    const [loaded, setLoaded] = useState(false);
    const [resized, setResized] = useState(false);
    const [imgStyle, setPositionAndSize] = useState();
    const imgRef = useRef(null);
    useEffect(() => {
        const tempImg = new Image();
        tempImg.src = src;
        tempImg.onload = () => {
            setPositionAndSize(resizeAndPositionImage(tempImg, maxWidth, maxHeight, maxArea, position));
            setResized(true);
        };
        return () => (tempImg.onload = null);
    }, [maxWidth, maxHeight, maxArea, src, position]);
    return typeof src === 'string' ? (React.createElement("svg", { width: '100%', height: '100%', style: {
            zIndex: belowGfx ? 0 : 50000000000,
            position: 'absolute',
            top: 0,
            left: 0,
            bottom: 0,
            right: 0
        }, viewBox: "0 0 1920 1080" },
        React.createElement("image", Object.assign({ onLoad: () => setLoaded(true), ref: imgRef }, imgStyle, { style: {
                visibility: !resized ? 'hidden' : 'visible'
            }, xlinkHref: src })))) : null;
};
//# sourceMappingURL=index.js.map